var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footer"},[_c('v-container',[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-img',{attrs:{"src":require('@/assets/feder.png'),"alt":"UE FEDER","max-width":"200px"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }